<template>
    <div class="call-or-buy mt-4 d-flex position-relative">
            <div class="box-btn-x text-center pt-2">
                <div :class="{
                        'bor-btn' : true,
                        'active'  : quantity >= 1
                    }">
                     <span :class="{
                                'btn_rdo' : true,
                                'btn_rdo_buy' : quantity >= 1
                            }" @click="select(1)"><i class="icon ion-md-cart mr-2"></i>Đặt mua</span>
                </div>
            </div>
            <div :class="{
                    'box-btn-x text-center pt-2' : true,
                    'pl-2' : $detect == 'mobile'
                }">
                <div :class="{
                        'bor-btn' : true,
                        'active-call'  : quantity == 0
                    }">
                    <span :class="{
                            'btn_rdo' : true,
                            'btn_rdo_call' : quantity == 0
                        }" @click="select(0)"><i class="icon ion-ios-call mr-2"></i>Gọi điện</span>
                </div>
            </div>
            <!-- <span :class="'btn_rdo' + (quantity == 1 ? ' btn_rdo_buy' : '')" @click="select(1)">Đặt mua</span> -->
            <!-- <span :class="'btn_rdo ml-2' + (quantity == 0 ? ' btn_rdo_call' : '')" @click="select(0)">Gọi điện</span> -->
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': true,
                    'position-absolute' : true,
                    'buy-call' : true
                }">Hiển thị nút</label>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            quantity: ''
        }
    },
    watch: {
        data(val){
            this.quantity = this.$formatNumber(val);
        },
    },
    created() {
        this.quantity = this.$formatNumber(this.data);
    },
    methods : {
        select(val){
            this.$emit('update:data', val);
        }
    }
}
</script>
<style lang='scss'>
    .box-btn-x {
        .bor-btn{
            padding: 10px;
            width: 131px;
            height: 70px;
            margin: 0 auto;
            border: 1px dashed #e5e5e5;
            border-radius: 4px;
            &.active{
                border: 1px dashed #f44f00;
            }
            &.active-call{
                border: 1px dashed #33a837;
            }
        }

    }
</style>
